/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { NgZone } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { TranslocoService } from '@ngneat/transloco';
import { Store } from '@ngxs/store';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SnackbarHelper } from '../../../../../../shared/helpers/snackbar-helper';
import { ObservableResult } from '../../../../../../shared/store';
import { ResourceDataService } from '../../../../services/editor/core/data.service';
import * as ResourceAdminActions from '../../../admin/resource-admin.actions';
import { ResourceAdminStateModel } from '../../../admin/resource-admin.state.model';

export class BasicActionHelpers {
  // static updateHeadline(
  //   state: ResourceEditorContentStateModel,
  //   patchState: (p: Partial<ResourceEditorContentStateModel>) => Partial<ResourceEditorContentStateModel>,
  //   { headline }: UpdateHeadline
  // ) {
  //
  //   patchState({
  //     content: {
  //       ...state.content,
  //       headline,
  //       contentChanged: true,
  //     },
  //     saveStatus: {
  //       ...state.saveStatus,
  //       saveFailureReason: '',
  //     },
  //     validationErrors: [],
  //   });
  // }
  //
  // static deleteResource(
  //   playlistUid: string,
  //   sectionUid: string,
  //   resourceUid: string,
  //   dataService: ResourceDataService,
  //   patchState: (p: Partial<ResourceEditorContentStateModel>) => Partial<ResourceEditorContentStateModel>,
  //   store: Store,
  //   snackBar: MatSnackBar,
  //   ngZone: NgZone,
  //   translocoService: TranslocoService,
  // ) {
  //
  //   // Call api only if sectionUid is provided
  //   const observable$: ObservableResult<void> = sectionUid ?
  //     dataService.deleteResource(playlistUid, sectionUid, resourceUid) :
  //     of({ isSuccess: true, error: undefined });
  //
  //   return observable$.pipe(
  //     tap(({ isSuccess, error }) => {
  //       if (isSuccess) {
  //         SnackbarHelper.showTranslatableSnackBar(ngZone, snackBar, translocoService, 'translations.cardDeleted');
  //         store.dispatch(new RedirectToPlaylistOrResourcePage());
  //         store.dispatch(new ResetState());
  //       } else {
  //         SnackbarHelper.showSnackBar(ngZone, snackBar, error);
  //       }
  //     })
  //   );
  // }

  static updateResourceHeadline(
    state: ResourceAdminStateModel,
    patchState: (p: Partial<ResourceAdminStateModel>) => Partial<ResourceAdminStateModel>,
    headline: string,
  ) {
    patchState({
      resource: {
        ...state.resource,
        content: {
          ...state.resource.content,
          headline: headline,
        },
      },
      contentChanged: true,
      saveStatus: {
        ...state.saveStatus,
        saveFailureReason: '',
      },
    });
  }

  static deleteResourceAdmin(
    playlistUid: string,
    sectionUid: string,
    resourceUid: string,
    dataService: ResourceDataService,
    store: Store,
    snackBar: MatSnackBar,
    ngZone: NgZone,
    translocoService: TranslocoService,
  ) {
    // Call api only if sectionUid is provided
    const observable$: ObservableResult<void> = sectionUid
      ? dataService.deleteResource(playlistUid, sectionUid, resourceUid)
      : of({ isSuccess: true, error: undefined });

    return observable$.pipe(
      tap(({ isSuccess, error }) => {
        if (isSuccess) {
          SnackbarHelper.showTranslatableSnackBar(ngZone, snackBar, translocoService, 'translations.cardDeleted');
          store.dispatch(new ResourceAdminActions.RedirectToPlaylistOrResourcePage());
          store.dispatch(new ResourceAdminActions.ResetResourceAdminState());
        } else {
          SnackbarHelper.showSnackBar(ngZone, snackBar, error);
        }
      }),
    );
  }
}
